import { getPageLinkForSlug } from '../routes/getPageInformation';
import { hasNativeRouteRedirection } from '../navigation/nativeRoutingRedirection';
import type { CanonicalParameters } from '~~/helpers/seo/types/CanonicalParameters';
import { SECURE_WEBSITE_PROTOCOL_PREFIX } from '~~/constants/http';
import { CANONICAL_RELATION } from '~~/constants/seo';
import { hasPrefix } from '../routes/prefixes';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export default ({
  domain,
  slug,
  prefix,
  countryCode,
  pageNumber,
  isPdp,
  isCategoryPage,
}: {
   domain: string,
   slug: string,
   prefix: string | undefined,
   countryCode: CountryCodeValue,
   pageNumber?: number,
   isPdp?: boolean,
   isCategoryPage?: boolean,
}): CanonicalParameters => {

  const adjustedSlug = slug ? getPageLinkForSlug(slug) : '/';
  let nativeRouteIndicator = '';

  if (isPdp) {

    nativeRouteIndicator = '/p';

  } else if (isCategoryPage) {

    nativeRouteIndicator = '/c';

  }
  const slugWithCorrectRouting = hasNativeRouteRedirection(countryCode)
    ? `${nativeRouteIndicator}${adjustedSlug}`
    : adjustedSlug;
  let href = `${SECURE_WEBSITE_PROTOCOL_PREFIX}${domain}${slugWithCorrectRouting}`;

  if (prefix && !hasPrefix(slug)) {

    href = `${SECURE_WEBSITE_PROTOCOL_PREFIX}${domain}/${prefix}${adjustedSlug}`;

  }

  if (pageNumber && pageNumber > 1) {

    href = `${href}?page=${pageNumber}`;

  }

  return {
    rel: CANONICAL_RELATION,
    href,
  };

};
